module.exports = __webpack_public_path__ + "img/thumb-default.27112d81.jpg";